<template>
  <CompanyManAppLayout page-title="Daily Reports" page-subtitle="Reporting schedule for the active location">
    <div class="pt-4 space-y-4">
      <div class="flex justify-between gap-3 flex-wrap">
        <select v-model="locationId" class="loc" @change="load">
          <option v-for="loc in locations" :key="loc.id" :value="loc.id">{{ loc.name }}</option>
        </select>
        <button class="btn" @click="load">Refresh</button>
      </div>
      <p v-if="error" class="text-red-400">{{ error }}</p>
      <div class="panel">
        <div v-for="r in reports" :key="r.id" class="row">
          <div class="time">{{ r.report_time }}</div>
          <div class="grow">
            <div class="title">{{ r.title }}</div>
            <div class="sub">{{ r.well_name }}</div>
          </div>
          <span class="pill" :class="r.status">{{ r.status_label }}</span>
        </div>
        <div v-if="!reports.length" class="empty">No reports scheduled.</div>
      </div>
    </div>
  </CompanyManAppLayout>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import CompanyManAppLayout from '@/components/layout/CompanyManAppLayout.vue'
import { buildApiUrl } from '@/config/api'

const locationId = ref(0)
const locations = ref<any[]>([])
const reports = ref<any[]>([])
const error = ref('')

async function load() {
  error.value = ''
  try {
    const qs = locationId.value ? `?location_id=${locationId.value}` : ''
    const res = await fetch(buildApiUrl(`company-man/dashboard${qs}`), {
      headers: { Authorization: `Bearer ${localStorage.getItem('auth_token') || ''}` },
    })
    const data = await res.json()
    if (!res.ok) throw new Error(data.error || 'Failed')
    locations.value = data.locations || []
    locationId.value = data.locationId || locationId.value
    reports.value = data.dashboard?.reports || []
  } catch (e: any) {
    error.value = e.message || 'Failed'
  }
}
onMounted(load)
</script>

<style scoped>
.loc,.btn{@apply px-3 py-2 rounded-lg bg-slate-800 border border-slate-600 text-white text-sm;}
.panel{@apply bg-slate-800/50 border border-slate-700/50 rounded-2xl p-4 space-y-2;}
.row{@apply flex items-center gap-3 p-3 rounded-xl bg-slate-900/60 border border-slate-700/50;}
.time{@apply w-14 text-center text-emerald-300 font-bold text-sm;}
.title{@apply text-white text-sm font-semibold;}
.sub{@apply text-slate-400 text-xs;}
.pill{@apply text-[10px] uppercase font-bold px-2 py-1 rounded-full bg-slate-700 text-slate-300;}
.pill.due{@apply bg-amber-900/50 text-amber-300;}
.pill.sent{@apply bg-sky-900/40 text-sky-300;}
.pill.ready{@apply bg-emerald-900/40 text-emerald-300;}
.empty{@apply text-slate-400 text-center py-8;}
</style>
